class CartWatcher {

  constructor() {
    this.init(); // Call init method in the constructor
  }

  async init() {
    await this.emitCartChanges();
    this.observeCartChanges();
  }

  async fetchCart() {
    try {
      const response = await fetch('/cart.js');
      if (!response.ok) throw new Error('Network response was not ok');
      return await response.json();
    } catch (error) {
      console.error('Failed to fetch cart:', error);
      return { items: [] }; // Return an empty cart if the fetch fails
    }
  }

  storeCart(cart) {
    localStorage.setItem('cart', JSON.stringify(cart));
  }

  storedCart() {
    return JSON.parse(localStorage.getItem('cart')) || { items: [] };
  }

  findCartChanges(oldCart, newCart) {
    const onlyInLeft = (l, r) => l.filter(li => !r.some(ri => li.key == ri.key));
    let result = {
      added: onlyInLeft(newCart.items, oldCart.items),
      removed: onlyInLeft(oldCart.items, newCart.items),
    };

    oldCart.items.forEach(oi => {
      const ni = newCart.items.find(i => i.key == oi.key && i.quantity != oi.quantity);
      if (!ni) return;
      let quantity = ni.quantity - oi.quantity;
      let item = { ...ni };
      item.quantity = Math.abs(quantity);
      quantity > 0
        ? result.added.push(item)
        : result.removed.push(item);
    });

    return result;
  }

  async emitCartChanges() {
    const newCart = await this.fetchCart();
    const oldCart = this.storedCart();
    const changes = this.findCartChanges(oldCart, newCart);

    const event = new CustomEvent("cart_changed", { detail: changes });
    window.dispatchEvent(event);

    this.storeCart(newCart);
  }

  observeCartChanges() {
    if (typeof PerformanceObserver !== 'undefined') {
      const cartObserver = new PerformanceObserver((list) => {
        list.getEntries().forEach((entry) => {
          const isValidRequestType = ['xmlhttprequest', 'fetch'].includes(entry.initiatorType);
          const isCartChangeRequest = /\/cart\//.test(entry.name);
          if (isValidRequestType && isCartChangeRequest) {
            this.emitCartChanges();
          }
        });
      });
      cartObserver.observe({ entryTypes: ["resource"] });
    } else {
      console.warn('PerformanceObserver is not supported in this browser.');
    }
  }

  // New method to get total number of items in the cart
  getTotalItems() {
    const cart = this.storedCart();
    return cart.items.reduce((total, item) => total + item.quantity, 0);
  }
  
}

const myCartWatcher = new CartWatcher();
// // window.addEventListener("cart_changed", e => console.log(e.detail));

// window.addEventListener("cart_changed",function(){
//   // console.log('Total items in cart:', myCartWatcher.getTotalItems());
//       setTimeout(function() {
//           // Corrected method for setting text content
//   document.querySelector('li.bot-item.bot-cart .cart-count-bubble').textContent = myCartWatcher.getTotalItems();
    
//       },400);

// });

// Example usage to get the total number of items in the cart
